import { render, staticRenderFns } from "./PrivacyDoc.vue?vue&type=template&id=659e4df0&scoped=true"
import script from "./PrivacyDoc.vue?vue&type=script&lang=js"
export * from "./PrivacyDoc.vue?vue&type=script&lang=js"
import style0 from "./PrivacyDoc.vue?vue&type=style&index=0&id=659e4df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e4df0",
  null
  
)

export default component.exports